import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import { LoadingScreen } from "Components";
import { newAuthService } from "Service/Axios";
import { getCareerHubJobsDetailsUrl } from "Constant/api";
import { paths } from "Constant/paths";

export const JobDetails = ({ show, jobId, toggle }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [jobDetailsLoading, setJobDetailsLoading] = useState(false);
  const [jobDetails, setJobDetails] = useState(null);

  // Function to fetch the job details
  const fetchJobDetailsList = async () => {
    setJobDetailsLoading(true);
    const payload = {
      gid: jobId,
    };
    const response = await newAuthService(
      getCareerHubJobsDetailsUrl,
      "POST",
      payload
    );
    setJobDetails(response.data);
    setJobDetailsLoading(false);
  };

  useEffect(() => {
    if (jobId) {
      fetchJobDetailsList();
    }
  }, [jobId]);

  // Function to handle the redirect to the apply page
  const onRedirectToApply = (formId, urlParameter, website, email) => {
    if (formId) {
      const formUrl = `${paths.formBuilder.applicationForm}/${formId}`;
      navigate(urlParameter ? `${formUrl}?${urlParameter}` : formUrl);
    } else if (website) {
      window.open(website, "_blank");
    } else if (email) {
      window.location.href = `mailto:${email}`;
    } else {
      toast.error(t("common.messages.notification.failed.somethingWentWrong"));
    }
  };

  return (
    <Modal
      show={show}
      onHide={toggle}
      className="modal text-start fade right modal-slider modal-max-w-overview h-100"
    >
      <Modal.Header closeButton className="rounded-0">
        <Modal.Title></Modal.Title>
      </Modal.Header>
      <Modal.Body className="text-slate-500">
        {jobDetailsLoading ? (
          <div className="h-100 d-flex justify-content-center align-items-center gap-3 job-loader"><LoadingScreen /></div>
        ) : jobDetails ? (
          <div className="p-3 d-flex flex-column gap-3">
            <div className="d-flex flex-column gap-3 border-bottom border-slate-200 pb-4">
              <div className="w-100 mx-auto flex-auto d-flex justify-content-center align-items-center">
                <img
                  src={jobDetails.image || ""}
                  alt={jobDetails.name}
                  className="img-fluid"
                />
              </div>
              <h3 className="mb-0 mx-auto text-md font-bold text-blue-600">
                {jobDetails.name}
              </h3>
            </div>

            <div dangerouslySetInnerHTML={{ __html: jobDetails.details }} />
          </div>
        ) : (
          <div className="p-3 d-flex flex-column gap-3">
            <p>Job Details Not Found</p>
          </div>
        )}
      </Modal.Body>
      {jobDetails && (
        <Modal.Footer className="rounded-0 text-slate-500">
          <button
            type="button"
            className="btn btn-primary btn-sm flex-auto"
            onClick={() =>
              onRedirectToApply(
                jobDetails.formId,
                jobDetails.urlParameter,
                jobDetails.website,
                jobDetails.email
              )
            }
          >
            Apply Now
          </button>
          <button
            type="button"
            className="text-blue-500 rounded border border-blue-200 bg-blue-100 w-9 h-9 d-flex justify-content-center align-items-center flex-auto"
          >
            {/* <span className="material-symbols-outlined">bookmark</span> */}
            <i className={`bx bx${jobDetails.save ? "s" : ""}-bookmark`}></i>
          </button>
        </Modal.Footer>
      )}
    </Modal>
  );
};
